import type { IconSvgObject } from './types';

const SquareArrowUpDownIcon: IconSvgObject = [
  ["path", { d: "M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 8V16M9 8C8.20516 8 7 10 7 10M9 8C9.78225 8 11 10 11 10M15 16V8M15 16C14.2178 16 13 14 13 14M15 16C15.7822 16 17 14 17 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.55", key: "1" }]
];

export default SquareArrowUpDownIcon;
